module.exports = __webpack_public_path__ + "img/AI Help.1339e3b7.svg";